import { render, staticRenderFns } from "./classesManageList.vue?vue&type=template&id=36b2ed5b&scoped=true"
import script from "./classesManageList.vue?vue&type=script&lang=js"
export * from "./classesManageList.vue?vue&type=script&lang=js"
import style0 from "./classesManageList.vue?vue&type=style&index=0&id=36b2ed5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2ed5b",
  null
  
)

export default component.exports